'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomNavigation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _core = require('@material-ui/core');

var _styles = require('@material-ui/styles');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      height: function height(props) {
        return props.height;
      },
      width: function width(props) {
        return props.width;
      },
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2)',
      background: '#fff',
      maxWidth: '100%',
      '& .Mui-selected': {
        '& .MuiBottomNavigationAction-wrapper': {
          '& .MuiSvgIcon-root': {
            color: 'var(--secondary-900) !important'
          },
          '& .MuiBottomNavigationAction-label': {
            color: 'var(--secondary-900)'
          }
        }
      }
    },
    navAction: {
      maxWidth: '100%',
      minWidth: 'auto',
      '& .MuiBottomNavigationAction-wrapper': {
        '& .MuiSvgIcon-root': {
          color: 'var(--secondary-300)'
        },
        '& .MuiBottomNavigationAction-label': {
          color: 'var(--secondary-300)',
          letterSpacing: 0.25,
          fontWeight: 500,
          fontSize: 12,
          lineHeight: '16px',
          fontFamily: 'Montserrat, "sans-serif"'
        }
      }
    }
  };
});

var BottomNavigation = function BottomNavigation(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      showLabels = _ref.showLabels,
      navs = _ref.navs,
      props = _objectWithoutProperties(_ref, ['onChange', 'value', 'showLabels', 'navs']);

  var classes = useStyles(props);
  return _react2.default.createElement(
    _core.BottomNavigation,
    _extends({
      value: value,
      className: classes.root,
      showLabels: showLabels,
      onChange: onChange
    }, props),
    navs.map(function (nav) {
      return _react2.default.createElement(_core.BottomNavigationAction, {
        key: nav.value,
        className: classes.navAction,
        label: nav.label,
        value: nav.value,
        icon: nav.icon
      });
    })
  );
};

exports.BottomNavigation = BottomNavigation;
BottomNavigation.defaultProps = {
  showLabels: true,
  width: 360,
  height: 56
};

BottomNavigation.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  showLabels: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  navs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string,
    icon: _propTypes2.default.node
  })).isRequired
};

exports.default = BottomNavigation;